if (document.querySelector('.swiper-project') !== null) {
  const mql = window.matchMedia('screen and (min-width: 768px)')
  const mobilePrams = {
    effect: 'slide',
    loop: true,
    grabCursor: true,
    slidesPerView: 'auto',
    centeredSlides: false,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next-project',
      prevEl: '.swiper-button-prev-project',
    },
  }
  const pcPrams = {
    loop: true,
    grabCursor: true,
    slidesPerView: 'auto',
    centeredSlides: false,
    navigation: {
      nextEl: '.swiper-button-next-project',
      prevEl: '.swiper-button-prev-project',
    },
    effect: 'creative',
    creativeEffect: {
      limitProgress: 2,
      prev: {
        translate: ['-100%', 0, 0],
        scale: 1,
        origin: 'top right',
      },
      next: {
        translate: ['100%', 0, 0],
        scale: 0.9,
        origin: 'top right',
      },
    },
  }
  let swiperProject = new Swiper('.swiper-project', mobilePrams)
  const slider = (mql) => {
    swiperProject.destroy(true, true)
    if (mql.matches) {
      swiperProject = new Swiper('.swiper-project', pcPrams)
    } else {
      swiperProject = new Swiper('.swiper-project', mobilePrams)
    }
  }
  mql.addListener(slider)
  slider(mql)
}

const swiperFeature = new Swiper('.swiper-feature', {
  loop: true,
  grabCursor: true,
  slidesPerView: 'auto',
  centeredSlides: false,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next-project',
    prevEl: '.swiper-button-prev-project',
  },
})

const swiperPeople = new Swiper('.swiper-people', {
  loop: true,
  grabCursor: true,
  slidesPerView: '2',
  centeredSlides: false,
  spaceBetween: 20,
  breakpoints: {
    768: {
      slidesPerView: 'auto',
    },
  },
})

const swiperArchive = new Swiper('.swiper-archive', {
  loop: true,
  grabCursor: true,
  slidesPerView: 'auto',
  centeredSlides: false,
  spaceBetween: 20,
  breakpoints: {
    768: {
      slidesPerView: '2',
    },
  },
  navigation: {
    nextEl: '.swiper-button-next-archive',
    prevEl: '.swiper-button-prev-archive',
  },
})

document.querySelectorAll('.slider').forEach((articleSlider) => {
  if (!articleSlider) return false

  const el = {
    main: articleSlider.querySelector('.swiper-article'),
    thumb: articleSlider.querySelector('.swiper-articleThumbnail'),
  }

  const slider = {}

  slider.thumb = new Swiper(el.thumb, {
    slidesPerView: 3,
    watchSlidesProgress: true,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next-articleThumbnail',
      prevEl: '.swiper-button-prev-articleThumbnail',
    },
    breakpoints: {
      768: {
        slidesPerView: '4',
      },
    },
  })

  slider.main = new Swiper(el.main, {
    effect: 'fade',
    loop: true,
    grabCursor: true,
    thumbs: {
      swiper: slider.thumb,
    },
  })
})

const links = document.querySelectorAll('a[href^="#"]')
links.forEach((link) => {
  link.addEventListener('click', (e) => {
    e.preventDefault()
    const href = link.getAttribute('href')
    const targetSection = document.querySelector(href)
    const sectionTop = targetSection.getBoundingClientRect().top
    const currentPos = window.scrollY
    const gap = 100
    const target = sectionTop + currentPos - gap
    window.scrollTo({
      top: target,
      behavior: 'smooth',
    })
  })
})
